function O(t, r, o, a, i, s, f, d, _) {
  switch (arguments.length) {
    case 1:
      return t;
    case 2:
      return r(t);
    case 3:
      return o(r(t));
    case 4:
      return a(o(r(t)));
    case 5:
      return i(a(o(r(t))));
    case 6:
      return s(i(a(o(r(t)))));
    case 7:
      return f(s(i(a(o(r(t))))));
    case 8:
      return d(f(s(i(a(o(r(t)))))));
    case 9:
      return _(d(f(s(i(a(o(r(t))))))));
    default: {
      for (var b = arguments[0], g = 1; g < arguments.length; g++)
        b = arguments[g](b);
      return b;
    }
  }
}
globalThis && globalThis.__spreadArray;
var ee = { _tag: "None" }, te = function(t) {
  return { _tag: "Some", value: t };
}, re = function(t) {
  return t._tag === "Left";
}, ne = function(t) {
  return { _tag: "Left", left: t };
}, ae = function(t) {
  return { _tag: "Right", right: t };
}, oe = ee, ie = te, se = function(t) {
  return t._tag === "None";
}, ue = function(t) {
  return function(r) {
    return se(r) ? t() : r.value;
  };
}, ce = ue, fe = function(t) {
  return t == null ? oe : ie(t);
}, V = /* @__PURE__ */ ((t) => (t.AE = "auto_equity", t.AF = "auto_fin", t.BE = "benefits", t.CA = "creditas_auto", t.CAC2C = "creditas_auto_c2c", t.CR = "cross", t.HE = "home_equity", t.HF = "home_financing", t.HS = "home_solutions", t.IS = "insurance", t.IN = "institutional", t.MX = "mexico", t.PA = "partnership", t.PAE = "partnership_auto_equity", t.PHE = "partnership_home_equity", t.PHF = "partnership_home_financing", t.PIS = "partnership_insurance", t))(V || {});
const le = (t, r) => {
  const o = {}, a = t[0](r);
  return o.page = a.page, o.identify = a.identify, o.track = a.track, o;
};
var de = ne, $ = ae, B = function(t) {
  return function(r) {
    return he(r) ? r : $(t(r.right));
  };
}, he = re, x = function(t) {
  return function(r) {
    return r == null ? de(t) : $(r);
  };
}, pe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ye(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var w = { exports: {} };
(function(t, r) {
  var o = typeof self < "u" ? self : pe, a = function() {
    function s() {
      this.fetch = !1, this.DOMException = o.DOMException;
    }
    return s.prototype = o, new s();
  }();
  (function(s) {
    (function(f) {
      var d = {
        searchParams: "URLSearchParams" in s,
        iterable: "Symbol" in s && "iterator" in Symbol,
        blob: "FileReader" in s && "Blob" in s && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in s,
        arrayBuffer: "ArrayBuffer" in s
      };
      function _(e) {
        return e && DataView.prototype.isPrototypeOf(e);
      }
      if (d.arrayBuffer)
        var b = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], g = ArrayBuffer.isView || function(e) {
          return e && b.indexOf(Object.prototype.toString.call(e)) > -1;
        };
      function y(e) {
        if (typeof e != "string" && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e))
          throw new TypeError("Invalid character in header field name");
        return e.toLowerCase();
      }
      function E(e) {
        return typeof e != "string" && (e = String(e)), e;
      }
      function P(e) {
        var n = {
          next: function() {
            var u = e.shift();
            return { done: u === void 0, value: u };
          }
        };
        return d.iterable && (n[Symbol.iterator] = function() {
          return n;
        }), n;
      }
      function l(e) {
        this.map = {}, e instanceof l ? e.forEach(function(n, u) {
          this.append(u, n);
        }, this) : Array.isArray(e) ? e.forEach(function(n) {
          this.append(n[0], n[1]);
        }, this) : e && Object.getOwnPropertyNames(e).forEach(function(n) {
          this.append(n, e[n]);
        }, this);
      }
      l.prototype.append = function(e, n) {
        e = y(e), n = E(n);
        var u = this.map[e];
        this.map[e] = u ? u + ", " + n : n;
      }, l.prototype.delete = function(e) {
        delete this.map[y(e)];
      }, l.prototype.get = function(e) {
        return e = y(e), this.has(e) ? this.map[e] : null;
      }, l.prototype.has = function(e) {
        return this.map.hasOwnProperty(y(e));
      }, l.prototype.set = function(e, n) {
        this.map[y(e)] = E(n);
      }, l.prototype.forEach = function(e, n) {
        for (var u in this.map)
          this.map.hasOwnProperty(u) && e.call(n, this.map[u], u, this);
      }, l.prototype.keys = function() {
        var e = [];
        return this.forEach(function(n, u) {
          e.push(u);
        }), P(e);
      }, l.prototype.values = function() {
        var e = [];
        return this.forEach(function(n) {
          e.push(n);
        }), P(e);
      }, l.prototype.entries = function() {
        var e = [];
        return this.forEach(function(n, u) {
          e.push([u, n]);
        }), P(e);
      }, d.iterable && (l.prototype[Symbol.iterator] = l.prototype.entries);
      function L(e) {
        if (e.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        e.bodyUsed = !0;
      }
      function I(e) {
        return new Promise(function(n, u) {
          e.onload = function() {
            n(e.result);
          }, e.onerror = function() {
            u(e.error);
          };
        });
      }
      function X(e) {
        var n = new FileReader(), u = I(n);
        return n.readAsArrayBuffer(e), u;
      }
      function z(e) {
        var n = new FileReader(), u = I(n);
        return n.readAsText(e), u;
      }
      function J(e) {
        for (var n = new Uint8Array(e), u = new Array(n.length), p = 0; p < n.length; p++)
          u[p] = String.fromCharCode(n[p]);
        return u.join("");
      }
      function N(e) {
        if (e.slice)
          return e.slice(0);
        var n = new Uint8Array(e.byteLength);
        return n.set(new Uint8Array(e)), n.buffer;
      }
      function M() {
        return this.bodyUsed = !1, this._initBody = function(e) {
          this._bodyInit = e, e ? typeof e == "string" ? this._bodyText = e : d.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : d.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : d.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : d.arrayBuffer && d.blob && _(e) ? (this._bodyArrayBuffer = N(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : d.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || g(e)) ? this._bodyArrayBuffer = N(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || (typeof e == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : d.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, d.blob && (this.blob = function() {
          var e = L(this);
          if (e)
            return e;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? L(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(X);
        }), this.text = function() {
          var e = L(this);
          if (e)
            return e;
          if (this._bodyBlob)
            return z(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(J(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, d.formData && (this.formData = function() {
          return this.text().then(Z);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var K = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function Y(e) {
        var n = e.toUpperCase();
        return K.indexOf(n) > -1 ? n : e;
      }
      function v(e, n) {
        n = n || {};
        var u = n.body;
        if (e instanceof v) {
          if (e.bodyUsed)
            throw new TypeError("Already read");
          this.url = e.url, this.credentials = e.credentials, n.headers || (this.headers = new l(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, !u && e._bodyInit != null && (u = e._bodyInit, e.bodyUsed = !0);
        } else
          this.url = String(e);
        if (this.credentials = n.credentials || this.credentials || "same-origin", (n.headers || !this.headers) && (this.headers = new l(n.headers)), this.method = Y(n.method || this.method || "GET"), this.mode = n.mode || this.mode || null, this.signal = n.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && u)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(u);
      }
      v.prototype.clone = function() {
        return new v(this, { body: this._bodyInit });
      };
      function Z(e) {
        var n = new FormData();
        return e.trim().split("&").forEach(function(u) {
          if (u) {
            var p = u.split("="), h = p.shift().replace(/\+/g, " "), c = p.join("=").replace(/\+/g, " ");
            n.append(decodeURIComponent(h), decodeURIComponent(c));
          }
        }), n;
      }
      function W(e) {
        var n = new l(), u = e.replace(/\r?\n[\t ]+/g, " ");
        return u.split(/\r?\n/).forEach(function(p) {
          var h = p.split(":"), c = h.shift().trim();
          if (c) {
            var S = h.join(":").trim();
            n.append(c, S);
          }
        }), n;
      }
      M.call(v.prototype);
      function m(e, n) {
        n || (n = {}), this.type = "default", this.status = n.status === void 0 ? 200 : n.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in n ? n.statusText : "OK", this.headers = new l(n.headers), this.url = n.url || "", this._initBody(e);
      }
      M.call(m.prototype), m.prototype.clone = function() {
        return new m(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new l(this.headers),
          url: this.url
        });
      }, m.error = function() {
        var e = new m(null, { status: 0, statusText: "" });
        return e.type = "error", e;
      };
      var Q = [301, 302, 303, 307, 308];
      m.redirect = function(e, n) {
        if (Q.indexOf(n) === -1)
          throw new RangeError("Invalid status code");
        return new m(null, { status: n, headers: { location: e } });
      }, f.DOMException = s.DOMException;
      try {
        new f.DOMException();
      } catch {
        f.DOMException = function(n, u) {
          this.message = n, this.name = u;
          var p = Error(n);
          this.stack = p.stack;
        }, f.DOMException.prototype = Object.create(Error.prototype), f.DOMException.prototype.constructor = f.DOMException;
      }
      function T(e, n) {
        return new Promise(function(u, p) {
          var h = new v(e, n);
          if (h.signal && h.signal.aborted)
            return p(new f.DOMException("Aborted", "AbortError"));
          var c = new XMLHttpRequest();
          function S() {
            c.abort();
          }
          c.onload = function() {
            var A = {
              status: c.status,
              statusText: c.statusText,
              headers: W(c.getAllResponseHeaders() || "")
            };
            A.url = "responseURL" in c ? c.responseURL : A.headers.get("X-Request-URL");
            var C = "response" in c ? c.response : c.responseText;
            u(new m(C, A));
          }, c.onerror = function() {
            p(new TypeError("Network request failed"));
          }, c.ontimeout = function() {
            p(new TypeError("Network request failed"));
          }, c.onabort = function() {
            p(new f.DOMException("Aborted", "AbortError"));
          }, c.open(h.method, h.url, !0), h.credentials === "include" ? c.withCredentials = !0 : h.credentials === "omit" && (c.withCredentials = !1), "responseType" in c && d.blob && (c.responseType = "blob"), h.headers.forEach(function(A, C) {
            c.setRequestHeader(C, A);
          }), h.signal && (h.signal.addEventListener("abort", S), c.onreadystatechange = function() {
            c.readyState === 4 && h.signal.removeEventListener("abort", S);
          }), c.send(typeof h._bodyInit > "u" ? null : h._bodyInit);
        });
      }
      return T.polyfill = !0, s.fetch || (s.fetch = T, s.Headers = l, s.Request = v, s.Response = m), f.Headers = l, f.Request = v, f.Response = m, f.fetch = T, Object.defineProperty(f, "__esModule", { value: !0 }), f;
    })({});
  })(a), a.fetch.ponyfill = !0, delete a.fetch.polyfill;
  var i = a;
  r = i.fetch, r.default = i.fetch, r.fetch = i.fetch, r.Headers = i.Headers, r.Request = i.Request, r.Response = i.Response, t.exports = r;
})(w, w.exports);
const me = /* @__PURE__ */ ye(w.exports), ge = async ({ email: t, userDocumentId: r, cellphone: o }, a) => new Promise((i) => {
  const s = r && { userDocumentId: r }, f = t && { email: t }, d = o && { cellphone: o }, _ = JSON.stringify({
    query: `query CreateStitchingUserId($email: String, $userDocumentId: String, $cellphone: String) {
      createStitchingUserId(email: $email, userDocumentId: $userDocumentId, cellphone: $cellphone) {
        data {
          contactId
        }
      }
    }`,
    variables: {
      ...s,
      ...f,
      ...d
    }
  }), b = new w.exports.Headers({
    "Content-Type": "application/json",
    Accept: "application/json"
  });
  let g = "https://api.creditas.io/customer-data-platform-bff/graphql";
  a.environment !== "production" && (g = "https://stg-api.creditas.io/customer-data-platform-bff/graphql"), me(new w.exports.Request(g), {
    method: "POST",
    body: _,
    headers: b
  }).then((y) => {
    if (y.status === 200)
      return y.json();
    throw new Error(
      "Bad response from server event-track customer-data-platform-bff"
    );
  }).then((y) => {
    var E;
    ((E = y == null ? void 0 : y.errors) == null ? void 0 : E.length) > 0 && i(null), i(y.data.createStitchingUserId.data.contactId);
  });
});
function R(t) {
  return String(t).replace(/[^\d]/g, "");
}
function be(t, r) {
  var o = R(t), a = typeof r == "number" ? Array(o.length).fill(0).map(function(i, s) {
    return r - s;
  }) : r;
  return o.split("").reduce(function(i, s, f) {
    return i + parseInt(s, 10) * a[f];
  }, 0);
}
var F = {
  AC: {
    code: "2",
    areaCodes: [68],
    ieLength: 13,
    name: "Acre"
  },
  AL: {
    code: "4",
    areaCodes: [82],
    ieLength: 9,
    name: "Alagoas"
  },
  AP: {
    code: "2",
    areaCodes: [96],
    ieLength: 9,
    name: "Amap\xE1"
  },
  AM: {
    code: "2",
    areaCodes: [92, 97],
    ieLength: 9,
    name: "Amazonas"
  },
  BA: {
    code: "5",
    areaCodes: [71, 73, 74, 75, 77],
    ieLength: [8, 9],
    name: "Bahia"
  },
  CE: {
    code: "3",
    areaCodes: [85, 88],
    ieLength: 9,
    name: "Cear\xE1"
  },
  DF: {
    code: "1",
    areaCodes: [61],
    ieLength: 13,
    name: "Distrito Federal"
  },
  ES: {
    code: "7",
    areaCodes: [27, 28],
    ieLength: 9,
    name: "Esp\xEDrito Santo"
  },
  GO: {
    code: "1",
    areaCodes: [62, 64],
    ieLength: 9,
    name: "Goi\xE1s"
  },
  MA: {
    code: "3",
    areaCodes: [98, 99],
    ieLength: 9,
    name: "Maranh\xE3o"
  },
  MG: {
    code: "6",
    areaCodes: [31, 32, 33, 34, 35, 37, 38],
    ieLength: 13,
    name: "Minas Gerais"
  },
  MT: {
    code: "1",
    areaCodes: [65, 66],
    ieLength: 11,
    name: "Mato Grosso"
  },
  MS: {
    code: "1",
    areaCodes: [67],
    ieLength: 9,
    name: "Mato Grosso do Sul"
  },
  PA: {
    code: "2",
    areaCodes: [91, 93, 94],
    ieLength: 9,
    name: "Par\xE1"
  },
  PB: {
    code: "4",
    areaCodes: [83],
    ieLength: 9,
    name: "Para\xEDba"
  },
  PE: {
    code: "4",
    areaCodes: [81, 87],
    ieLength: 9,
    name: "Pernambuco"
  },
  PI: {
    code: "3",
    areaCodes: [86, 89],
    ieLength: 9,
    name: "Piau\xED"
  },
  PR: {
    code: "9",
    areaCodes: [41, 42, 43, 44, 45, 46],
    ieLength: 10,
    name: "Paran\xE1"
  },
  RJ: {
    code: "7",
    areaCodes: [21, 22, 24],
    ieLength: 8,
    name: "Rio de Janeiro"
  },
  RN: {
    code: "4",
    areaCodes: [84],
    ieLength: [9, 10],
    name: "Rio Grande do Norte"
  },
  RO: {
    code: "2",
    areaCodes: [69],
    ieLength: 14,
    name: "Rond\xF4nia"
  },
  RS: {
    code: "0",
    areaCodes: [51, 53, 54, 55],
    ieLength: 10,
    name: "Rio Grande do Sul"
  },
  RR: {
    code: "2",
    areaCodes: [95],
    ieLength: 9,
    name: "Roraima"
  },
  SC: {
    code: "9",
    areaCodes: [47, 48, 49],
    ieLength: 9,
    name: "Santa Catarina"
  },
  SE: {
    code: "5",
    areaCodes: [79],
    ieLength: 9,
    name: "Sergipe"
  },
  SP: {
    code: "8",
    areaCodes: [11, 12, 13, 14, 15, 16, 17, 18, 19],
    ieLength: 12,
    name: "S\xE3o Paulo"
  },
  TO: {
    code: "1",
    areaCodes: [63],
    ieLength: [9, 11],
    name: "Tocantins"
  }
}, ve = /* @__PURE__ */ Object.keys(F).reduce(function(t, r) {
  return t.concat(F[r].areaCodes);
}, []), q = 10, U = 11, _e = [6, 7, 8, 9], Ee = [2, 3, 4, 5];
function Ae(t) {
  return ve.includes(Number(t.substr(0, 2)));
}
function we(t) {
  return t.length === U;
}
function Se(t) {
  return t.length >= q && t.length < U;
}
function Pe(t) {
  return Se(t) || we(t);
}
function Le(t) {
  return _e.includes(Number(t.charAt(2)));
}
function Te(t) {
  return Ee.includes(Number(t.charAt(2)));
}
function Ce(t) {
  return t.length === q ? Te(t) : Le(t);
}
function De(t) {
  return {
    isValidDigits: !!t && typeof t == "string",
    digits: R(t)
  };
}
function Oe(t) {
  var r = De(t), o = r.isValidDigits, a = r.digits;
  return o ? Pe(a) && Ce(a) && Ae(a) : !1;
}
var G = 64, k = 253, Re = G + 1 + k, Ie = /^([!#$%&'*+\-/=?^_`{|}~]{0,1}([a-zA-Z0-9][!#$%&'*+\-/=?^_`{|}~.]{0,1})+)@(([a-zA-Z0-9][-.]{0,1})+)([.]{1}[a-zA-Z0-9]+)$/, D = function(r) {
  for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
    a[i - 1] = arguments[i];
  return a.reduce(function(s, f) {
    return s + f.length;
  }, 0) > r;
};
function Ne(t) {
  if (!t || typeof t != "string" || D(Re, t))
    return !1;
  var r = Ie.exec(t);
  if (!r)
    return !1;
  var o = r[1], a = r[3], i = r[5];
  return !(D(G, o) || D(k, a, i));
}
var Me = ["00000000000", "11111111111", "22222222222", "33333333333", "44444444444", "55555555555", "66666666666", "77777777777", "88888888888", "99999999999"], Be = [9, 10];
function xe(t) {
  return /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/.test(t);
}
function Fe(t) {
  return Me.indexOf(t) >= 0;
}
function je(t) {
  return Be.every(function(r) {
    var o = be(t.slice(0, r).split("").reduce(function(a, i) {
      return a + i;
    }, ""), r + 1) % 11;
    return t[r] === String(o < 2 ? 0 : 11 - o);
  });
}
function He(t) {
  if (!t || typeof t != "string")
    return !1;
  var r = R(t);
  return xe(t) && !Fe(r) && je(r);
}
const j = (t) => t.replace(/\W/g, ""), Ve = (t) => {
  const r = Object.entries(t).map(([o, a]) => {
    const i = String(a);
    return He(i) ? ["userDocumentId", j(i)] : Oe(i) ? ["cellphone", j(i)] : Ne(i) ? ["email", a] : [o, a];
  });
  return Object.fromEntries(r);
}, $e = async (t, r, o) => {
  const a = [...r];
  if (typeof r[0] == "string" && a.splice(0, 1), typeof a[0] == "object") {
    const i = Ve(a[0]);
    if (!!i.userDocumentId || !!i.email || !!i.cellphone) {
      const s = await ge(i, o);
      if (s)
        return t.identify(s, { ...i, ...a[0] });
    }
    return t.identify(a[0]);
  }
};
function qe(t) {
  return {
    name: "segment-plugin",
    page: (...r) => {
      O(
        window.analytics,
        x("nully"),
        B((o) => {
          o.page(...r);
        })
      );
    },
    track: (...r) => {
      r[1] = { ...t, ...r[1] }, O(
        window.analytics,
        x("nully"),
        B((o) => {
          o.track(...r);
        })
      );
    },
    identify: async (...r) => {
      if (window.analytics)
        return await $e(window.analytics, r, t);
    }
  };
}
const Ge = ({
  bu: t,
  application: r,
  environment: o,
  plugins: a,
  ...i
}) => {
  const s = O(
    a,
    fe,
    ce(() => [qe])
  ), f = {
    bu: V[t],
    application: r,
    environment: o,
    ...i
  };
  return le(s, f);
}, Ue = {
  acceptAnonymous: !1
}, H = {
  USER_ID_KEY: "ajs_user_id",
  ANONYMOUS_KEY: "ajs_anonymous_id"
}, ke = (t = Ue) => {
  const { acceptAnonymous: r } = t, o = JSON.parse(localStorage.getItem(H.USER_ID_KEY)), a = JSON.parse(localStorage.getItem(H.ANONYMOUS_KEY));
  return r ? o != null ? o : a : o;
};
export {
  Ge as configure,
  ke as getStorageUserId,
  H as stores
};
